import { fn } from '@common/utils';
import resolveToError = fn.resolveToError;

/** Events Triggered for FormSession Instance */
export const SessionEvents = {
    /** Trigger for Change (and Reset/Destroy) of currently Displayed Edit Page Item (Wizard/Purch/Sales Item) */
    displaychange: "displaychange",
    /** Display Page name has changed */
    displaypagechange : "displaypagechange",
    /** A Change took place (Value Set, Operation Executed, etc) which invalidates current actions state */
    change: "change",
    /** Destruction of Instance */
    destroy: "destroy",
    /** Instance got destroyed */
    destroyed: "destroyed",
    /** after UI attached */
    rendered: "rendered",
    /** deferrable event */
    applycurrentfieldinfo: "applycurrentfieldinfo",
    /** UI Selection of Main Line Data Changed */
    MainLineSelectionChanged: "MainLineSelectionChanged",
    /** UI Selection  LuGM Line Data Changed*/
    LuGMLineSelectionChanged: "LuGMLineSelectionChanged",
    /** Deferrable Event on Refresh State */
    RefreshState: "RefreshState",
    /** An Operation has been Executed */
    ActionExecuted : "ActionExecuted"
};

/** Events Triggered for Service */
export const ServiceEvents = {
    /** Cancellable event for applying Mandatory Fields in RWF3 on KWF3 Adapter */
    ApplyMandatoryFields: "ApplyMandatoryFields",
    /** Event when mandatory/readonly state gets applied */
    ApplyFieldsInfo: "ApplyFieldsInfo",
};

/** Property for the Lugm Lines */
export const PROP_LuGMAddRec = "LuGMAddRec",
    PROP_PurchLines = "PurchLines",
    PROP_SalesLines = "SalesLines",
    /** Document Type */
    PROP_Document_Type = "Document_Type",
    /** Marker Prop : CheckOrderInformation */
    PROP_OrderNo = "OrderNo",
    /** Line Item : Marker : "Bestellzeile" */
    PROP_Order_Line_No = "Order_Line_No",
    /** Marker Prop : Invalidate CheckOrderInformation result */
    PROP_SumLines = "SumLines";

/** QQQ: Custom broadcast notification to get notified about cancelled locationChange */
export const $locationChangeCancel = "$locationChangeCancel";

// TODO : kam TESTFIELD LineBreaks seem to be masked as "\" (WTF)
export function ErrToMsg(err: any): string {
    if (typeof err !== "string")
        err = resolveToError(err);

    if (typeof err === "string")
        err = err.replace(/\\/g, "\n");
    return err;
}
